module.exports = __webpack_public_path__ + "static/img/d301.09530318.png";